/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { getParticpantsI18n } from 'Components/utils/activities/activities.utils';
import { useCartLocked } from 'Utils/ple-utils';
import { t } from 'Src/i18n';
import { upSellTypeMapping } from 'Views/booking/booking-confirmation/BookingConfirmationTracking.utils';
import { FeatureCard } from 'Components/frameworks/feature-card/FeatureCard';
import { UpsellBooking } from 'Components/widgets/upsell-booking/UpsellBooking';
type Props = {
  activity: ActivityEntity;
  bookingId?: string;
  className?: string;
  onBook?: (() => void) | null | undefined;
};
export const REMAINING_STOCK_WARNING_THRESHOLD = 8;
export const ActivityCard = ({ activity, bookingId, className, onBook }: Props) => {
  const { isCartLocked } = useCartLocked(bookingId);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  if (!activity) {
    return null;
  }

  const {
    additionalService,
    ageRestriction,
    description,
    duration,
    equipments,
    furtherInformation,
    id,
    images,
    isIncluded,
    level,
    name,
    participants,
    seasonality,
    services,
    subtitle,
    transportation,
    treatments,
    upsellType,
  } = activity;
  const list = [
    {
      label: t('common.group'),
      value: participants
        ? t(getParticpantsI18n(participants), {
            max: participants.max || '',
            min: participants.min || '',
          })
        : null,
    },
    {
      label: t('common.age'),
      note: ageRestriction?.specificConditions,
      value: ageRestriction?.formatted,
    },
    {
      label: t('common.level'),
      value: level,
    },
    {
      label: t('common.seasonality'),
      value: seasonality,
    },
    {
      label: t('common.transportation'),
      value: transportation,
    },
    {
      label: t('common.equipments'),
      value: equipments,
    },
    {
      label: t('common.services'),
      value: services,
    },
    {
      label: t('common.treatmentsLabel'),
      value: treatments,
    },
  ].filter((l) => l.value);
  const schedules = additionalService?.pricingInfo?.schedules || [];
  const remainingStocksByDate = schedules.map(({ slots }) => ({
    quantity: slots[0].remainingStock,
  }));
  const remainingStock = remainingStocksByDate.filter(
    ({ quantity }) => quantity <= REMAINING_STOCK_WARNING_THRESHOLD,
  )[0];
  return (
    <UpsellBooking onBook={onBook} upsell={activity}>
      {({ currentPrice, isAdded, isLoading, isUnavailable, onExpand, onSubmit }) => (
        <div
          className="cursor-pointer"
          onClick={() => {
            setIsExpanded(!isExpanded);
            onExpand && onExpand(isExpanded);
          }}
        >
          <FeatureCard
            className={className}
            description={description}
            duration={duration}
            id={id}
            images={images}
            isAdded={isAdded}
            isIncluded={isIncluded}
            isLoading={isLoading}
            isUnavailable={isUnavailable}
            isCartLocked={isCartLocked}
            list={list}
            name={name}
            note={furtherInformation}
            onBook={onSubmit}
            isExpanded={isExpanded}
            price={currentPrice}
            remainingStock={remainingStock}
            subtitle={subtitle}
            showSliderOfImages={upsellType === upSellTypeMapping.EXCURSION}
          />
        </div>
      )}
    </UpsellBooking>
  );
};
